import React, {
  Fragment,
  useEffect,
  useState,
  useCallback,
  useRef,
} from "react";
import { set, useForm } from "react-hook-form";
import Select from "react-select";
import { toast } from "react-toastify";
import { useTranslation } from 'react-i18next';
import {
  Row,
  Col,
  CardHeader,
  CardBody,
  CardFooter,
  Form,
  FormGroup,
  Label,
  Input,
  Card,
} from "reactstrap";
import { useNavigate, useLocation } from "react-router-dom";
import { Btn, H4, H5, Spinner, Image, LI } from "../../../AbstractElements";
import Dropzone1 from "../../Bonus UI/Dropzones/Dropzone1";
import SingleSelect from "../../SingleSelect/SingleSelect";
import axios from "axios";
import { Trash2 } from "react-feather";
import SimpleMDE from "react-simplemde-editor";

const EditMyProfile = () => {
  const editorRef = useRef(null);
  const [name, setName] = React.useState("");
  const token = localStorage?.getItem("token");
  const [loading, setLoading] = useState(false);
  const { t } = useTranslation();
  const num = localStorage?.getItem("currentUser");

  const isInitialRender = useRef(true);
  const [email, setEmail] = useState("");
  const [emailValid, setEmailValid] = useState(true);
  const firm_status2 = ["Inactive", "Active"];
  const firm_status3 = ["Unpaid", "Paid"];
  const nameA = localStorage?.getItem("Name");
  const navigate = useNavigate();
  const [longitudeValid, setLongitudeValid] = useState(true);
  const [latitudeValid, setLatitudeValid] = useState(true);
  const locationn = useLocation();
  const [paymentType, setPaymentType] = useState();
  const { id } = locationn.state;
  const [otherDoc, setOtherDoc] = useState([]);
  const [otherDocS, setOtherDocS] = useState([]);
  const [firmOption2, setFirmOption2] = useState();
  const [firmOption3, setFirmOption3] = useState();
  const [firmOption4, setFirmOption4] = useState();
  const [positionOption, setSelectedPositionOption] =
  useState("MD");
   const [noOfYears, setNoOfYears] = useState(0);
  const [firmOption5, setFirmOption5] = useState();
  const [paymentProof, setPaymentProof] = useState('');
  const [paymentProof2, setPaymentProof2] = useState('');
  const [paymentProof3, setPaymentProof3] = useState('');
  const [paymentProof4, setPaymentProof4] = useState('');
  const [phone_number, setPhoneNumber] = React.useState("");
  const [same, setSame] = React.useState(false);
  const [person_name, setPersonName] = React.useState("");
  const [location, setLocation] = useState({ latitude: null, longitude: null });
  const [latitude, setLatitude] = useState("");
  const [longitude, setLongitude] = useState("");
  const [error, setError] = useState(null);

  const validateEmail = (em) => {
    const re = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return re.test(String(em).toLowerCase());
  };


  const [text, setText] = useState(``);

  const handleChange = (value) => {
    setText(value);
    if (editorRef.current) {
      editorRef.current.codemirror.focus();
    }
  };

  const [position, setPosition] = useState("");
  const [signature, setSignature] = useState("");
  const [nameOfFirm, setNameOfFirm] = useState("");
  const [address, setAddress] = useState("");
  const [proReqFees, setProReqFees] = useState(0);
  const [stampOfFirm, setStampOfFirm] = useState("");
  const [panNumber, setPanNumber] = useState("");
  const [nameOfOrganization, setNameOfOrganization] = useState("");
  const [contactPerson, setContactPerson] = useState("");
  const [province, setProvince] = useState("");
  const [placeRemain, setPlaceRemain] = useState(0);
  const [district, setDistrict] = useState("");
  const [city, setCity] = useState("");
  const [profilePic, setProfilePic] = useState("");
  const [currentUpload, setCurrentUpload] = useState("");
  const [nextPage, setNextPage] = useState(false);
  const [proofPic, setProofPic] = useState("");
  const [stampPic, setStampPic] = useState();
  const [supportingPic, setSupportingPic] = useState();
  const [supportingPic2, setSupportingPic2] = useState();
  const [supportingPicS, setSupportingPicS] = useState();
  const [supportingPic2S, setSupportingPic2S] = useState();
  const [regisPic, setRegisPic] = useState("");
  const [profile_status, setProfileStatus] = useState(false);
  const [proofPicS, setProofPicS] = useState("");
  const [stampPicS, setStampPicS] = useState("");
  const [regisPicS, setRegisPicS] = useState("");
  const [profilePicS, setProfilePicS] = useState("");


  const positions = [
    "MD",
    "Director",
    "CEO",
    "Manager",
    "Proprietor",
    "Other",
  ];


  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm();
  const onEditSubmit = (data, files, allFiles) => {
    allFiles.forEach((f) => f.remove());

    toast.success("Dropzone successfully submitted !");
    alert("Form is Submitted");
  };

  const getUploadParams = ({ meta }) => {
    return { url: "https://httpbin.org/post" };
  };

  const validateImageDimensions2 = (file, callback) => {
    const reader = new FileReader();
    reader.onload = (event) => {
      //const img = new window.Image();;
      const img = new window.Image();
      img.src = event.target.result;

      img.onload = () => {
        const maxWidth = 160; // Maximum allowed width
        const maxHeight = 160; // Maximum allowed height

        if (img.width > maxWidth || img.height > maxHeight) {
          callback(
            false,
            `Image dimensions must be smaller than ${maxWidth}x${maxHeight}px. Uploaded image size: ${img.width}x${img.height}px.`
          );
        } else {
          callback(true);
        }
      };
    };
    reader.readAsDataURL(file);
  };

  const handleChangeStatus = async ({ meta, file, remove }, status) => {
    if (status === 'done') {
      try {
        // Resize the image to fit within a 134x170 box
        const resizedFile = await resizeImage(file, 160, 160);

        console.log('Original file size:', file.size);
        console.log('Resized file size:', resizedFile.size);

        // Set the new, resized file in your state
        setStampPic(resizedFile);

        toast.success('Image has been resized and is ready!');

      } catch (error) {
        console.error('Image processing failed:', error);
        toast.error('Could not process the image. Please try a different file.');
        remove(); // Remove the file from the dropzone on error
      }
    }

    if (status === 'removed') {
      // Handle file removal if needed
      setStampPic(null);
    }
  };


  const getUploadParams2 = ({ meta }) => {
    return { url: "https://httpbin.org/post" };
  };
  const handleChangeStatus2 = ({ meta, file }, status) => {
    setSupportingPic(file);
  };

  const getUploadParams3 = ({ meta }) => {
    return { url: "https://httpbin.org/post" };
  };
  const handleChangeStatus3 = ({ meta, file }, status) => {
    setSupportingPic2(file);
  };
  /*const handleSubmit = (files, allFiles) => {
    allFiles.forEach(f => f.remove());
    toast.success('Dropzone successfully submitted !');
  };*/
  //hello how are you
  const handleCheckboxChange = (e) => {
    if (nameA !== "null") {
      setSame(e.target.checked);
      if (same) {
        setContactPerson("");
        setPhoneNumber("");
      } else {
        setContactPerson(nameA);
        setPhoneNumber(num);
      }
    } else {
      toast.error("There is no name currently.");
    }
  };

  const [provinceOption, setSelectedProvinceOption] =
    useState("Province No. 1");
  const [districtOption, setSelectedDistrictOption] = useState("Biratnagar");
  const [firmOption, setFirmOption] = useState();
  const [cityOption, setSelectedCityOption] = useState("");
  const [titleOption, setSelectedTitleOption] = useState([
    {
      value: "Automobile Spare Parts",
      label: "Automobile Spare Parts",
    },
  ]);
  const [nameValid, setNameValid] = useState(true);
  const [mobileValid, setMobileValid] = useState(true);
  const [addressValid, setAddressValid] = useState(true);
  const [positionValid, setPositionValid] = useState(true);
  const [pendingAmt, setPendingAmt] = useState();
  const [stampValid, setStampValid] = useState(true);
  const [profilePicValid, setProfilePicValid] = useState(true);
  const [panValid, setPanValid] = useState(true);
  const [nameOfFirmValid, setNameOfFirmValid] = useState(true);
  const [nameOfOrganizationValid, setNameOfOrganizationValid] = useState(true);
  const [contactPersonValid, setContactPersonValid] = useState(true);
  const [provinceValid, setProvinceValid] = useState(true);
  const [districtValid, setDistrictValid] = useState(true);
  const [districts, setDistricts] = useState([
    "Bhojpur",
    "Dhankuta",
    "Ilam",
    "Jhapa",
    "Khotang",
    "Morang",
    "Okhaldhunga",
    "Panchthar",
    "Sankhuwasabha",
    "Solukhumbu",
    "Sunsari",
    "Taplejung",
    "Terhathum",
    "Udayapur",
  ]);
  const [cities, setCities] = useState(["Biratnagar", "Dharan", "Itahari"]);
  const [cityValid, setCityValid] = useState(true);
  const [phoneNumberValid, setPhoneNumberValid] = useState(true);
  const [typeOfOrganizationValid, setTypeOfOrganizationValid] = useState(true);
  const [proofPicValid, setProofPicValid] = useState(true);

  const [filteredDistricts, setFilteredDistricts] = useState([]);
  const [filteredCities, setFilteredCities] = useState([]);

  const [selectedRadioIndex, setSelectedRadioIndex] = useState();

  const titles = [
    { value: "Automobile Spare Parts", label: "Automobile Spare Parts" },
    { value: "Accessories", label: "Accessories" },
    { value: "Tools", label: "Tools" },
    { value: "Batteries", label: "Batteries" },
    { value: "Tyres & Tubes", label: "Tyres & Tubes" },
    { value: "Lubricants", label: "Lubricants" },
    { value: "Vehicles", label: "Vehicles" },
    { value: "Motorcycle", label: "Motorcycle" },
    { value: "Tractor", label: "Tractor" },
    { value: "Tempo", label: "Tempo" },
    { value: "Heavy Equipments", label: "Heavy Equipments" },
    { value: "Workshop Equipments", label: "Workshop Equipments" },
  ];

  const provinces = [
    "Province No. 1",       // Formerly Province No. 1
    "Province No. 2",     // Formerly Province No. 2
    "Bagmati Province",
    "Gandaki Province",
    "Lumbini Province",
    "Karnali Province",
    "Sudurpashchim Province",
  ];

  const unfilteredDistricts = {
    "Province No. 1": [
      "Bhojpur",
      "Dhankuta",
      "Ilam",
      "Jhapa",
      "Khotang",
      "Morang",
      "Okhaldhunga",
      "Panchthar",
      "Sankhuwasabha",
      "Solukhumbu",
      "Sunsari",
      "Taplejung",
      "Terhathum",
      "Udayapur",
    ],
    "Province No. 2": [
      "Bara",
      "Dhanusha",
      "Mahottari",
      "Parsa",
      "Rautahat",
      "Saptari",
      "Sarlahi",
      "Siraha",
    ],
    "Bagmati Province": [
      "Bhaktapur",
      "Chitwan",
      "Dhading",
      "Dolakha",
      "Kathmandu",
      "Kavrepalanchok",
      "Lalitpur",
      "Makwanpur",
      "Nuwakot",
      "Ramechhap",
      "Rasuwa",
      "Sindhuli",
      "Sindhupalchok",
    ],
    "Gandaki Province": [
      "Baglung",
      "Gorkha",
      "Kaski",
      "Lamjung",
      "Manang",
      "Mustang",
      "Myagdi",
      "Nawalparasi East", // Corresponds to NAWALPUR in some datasets
      "Parbat",
      "Syangja",
      "Tanahu",
    ],
    "Lumbini Province": [
      "Arghakhanchi",
      "Banke",
      "Bardiya",
      "Dang",
      "Gulmi",
      "Kapilvastu",
      "Nawalparasi West", // Corresponds to PARASI in some datasets
      "Palpa",
      "Pyuthan",
      "Rolpa",
      "Rukum East",      // Corresponds to RUKUM_E in your file
      "Rupandehi",
    ],
    "Karnali Province": [
      "Dailekh",
      "Dolpa",
      "Humla",
      "Jajarkot",
      "Jumla",
      "Kalikot",
      "Mugu",
      "Rukum West",
      "Salyan",
      "Surkhet",
    ],
    "Sudurpashchim Province": [
      "Achham",
      "Baitadi",
      "Bajhang",
      "Bajura",
      "Dadeldhura",
      "Darchula",
      "Doti",
      "Kailali",
      "Kanchanpur",
    ],
  };

  const unfilteredCities = {
    "Province No. 1": [
      "Aathrai Tribeni", "Arjundhara", "Barahachhetra", "Barhadashi",
      "Belaka", "Bhojpur", "Biratnagar", "Birtamod", "Buddhashanti",
      "Chainpur", "Chulachuli", "Chisangkhugadhi", "Damak", "Deumai",
      "Dhankuta", "Dharan", "Falelung", "Falgunanda", "Gauradhaha",
      "Haldibari", "Hatuwagadhi", "Ilam", "Inaruwa", "Itahari", "Jahada",
      "Kachankawal", "Kamal", "Katari", "Kepilasgadhi", "Khumbupasanglahmu",
      "Kummayak", "Letang", "Likhu", "Maijogmai", "Maiwakhola", "Manebhanjyang",
      "Mangsebung", "Meringden", "Miklajung", "Morang", "Pathari Shanischare",
      "Panchakanya", "Phidim", "Ratuwamai", "Rong", "Sandakpur",
      "Shivasatakshi", "Sidingba", "Sirijangha", "Solududhkunda",
      "Sundarharaincha", "Suryodaya", "Taplejung", "Tehrathum",
      "Udayapurgadhi", "Urlabari", "Yangwarak"
    ],
    "Province No. 2": [
      "Adarshkotwal", "Aurahi", "Bagmati", "Bishnupur", "Birgunj",
      "Chhinnamasta", "Gaushala", "Godaita", "Haripur", "Haripurwa",
      "Ishnath", "Janakpur", "Jitpur Simara", "Kalaiya", "Karjanha",
      "Lahan", "Mahagadhimai", "Manara Shiswa", "Matihani", "Paroha",
      "Patarauta", "Pokhariya", "Rajbiraj", "Sabaila", "Sarlahi"
    ],
    "Bagmati Province": [
      "Bagmati", "Banepa", "Belkotgadhi", "Benighatrorang", "Bethanchok",
      "Bhaktapur", "Bharatpur", "Bhimeshwor", "Bhumlu", "Bidur", "Chaurideurali",
      "Chitwan", "Dhading", "Dhunibeshi", "Dhulikhel", "Doramba", "Gajuri",
      "Galchhi", "Gokulganga", "Hetauda", "Indrasarowar", "Jugal", "Kageshwari Manohara",
      "Kalinchok", "Kamalamai", "Kathmandu", "Kavrepalanchok", "Khanikhola",
      "Lalitpur", "Likhu Tamakoshi", "Lisankhu Pakhar", "Madanpur", "Mahabharat",
      "Makwanpurgadhi", "Mandandeupur", "Manthali", "Melamchi", "Namobuddha",
      "Narayani", "Nilkantha", "Panchakanya", "Panchpokhari Thangpal", "Panauti",
      "Phikkal", "Ramechhap", "Rasuwa", "Rautamai", "Roshiba", "Ruby Valley",
      "Shailung", "Sindhuli", "Sindhupalchok", "Sunkoshi", "Suryabinayak",
      "Tarkeshwar", "Thaha", "Tokha", "Tripurasundari", "Umakunda"
    ],
    "Gandaki Province": [
      "Aanbukhaireni", "Aarughat", "Ajirkot", "Annapurna", "Baglung",
      "Bandipur", "Barpak Sulikot", "Besisahar", "Bhanu", "Bhimad",
      "Bim", "Chame", "Chunumanubri", "Galkot", "Gandaki", "Gharapjhong",
      "Gorkha", "Harinas", "Jaimini", "Kaski", "Kawasoti", "Lamjung",
      "Machhapuchchhre", "Madi", "Manang", "Marsyangdi", "Modi", "Mustang",
      "Myagdi", "Nishi", "Palungtar", "Parbat", "Pokhara", "Putalibazar",
      "Rainas", "Rishing", "Rupa", "Sarkhu", "Shahid Lakhan", "Syangja",
      "Tanahu", "Tarakhola", "Thasang"
    ],
    "Lumbini Province": [
      "Airawati", "Arghakhanchi", "Badhaiyatal", "Banganga", "Banglachuli",
      "Banke", "Bardaghat", "Bardiya", "Bhumekasthan", "Buddhabhumi",
      "Butwal", "Chhatradev", "Dang", "Dangisharan", "Devdaha",
      "Dhorpatan Hunting Reserve", "Gadhawa", "Gaumukhi", "Geruwa", "Ghorahi",
      "Gulariya", "Gulmi", "Jhimruk", "Kapilvastu", "Krishnanagar",
      "Lumbini Sanskritik", "Lumbini", "Machhapuchhre", "Maharajgunj",
      "Malika", "Mandandeupur", "Mathagadhi", "Mayadevi", "Naubahini",
      "Omsatiya", "Palpa", "Panini", "Pratappur", "Putha Uttarganga",
      "Pyuthan", "Raina Devi Chhahara", "Rampur", "Ribdikot", "Rohini",
      "Rolpa", "Runtigadhi", "Rupandehi", "Sainamaina", "Sammarimai",
      "Sandhikharka", "Sarawal", "Shiwapur", "Shivaraj", "Shuddhodhan",
      "Siddharthanagar", "Sisne", "Sunawal", "Siyari", "Tansen", "Thawang",
      "Tilottama", "Tulsipur", "Yashodhara"
    ],
    "Karnali Province": [
      "Aathbiskot", "Barekot", "Bheriganga", "Bheri", "Birkot", "Chaukune",
      "Chhedagad", "Chhayanath Rinpoche", "Dailekh", "Darma", "Dullu",
      "Gurbhakot", "Hima", "Jagadulla", "Jajarkot", "Jumla", "Kalikot",
      "Kankasundari", "Khatyad", "Kumakh", "Lekbesi", "Mahabu", "Mugu",
      "Naumule", "Panchapuri", "Patarasi", "Raskot", "Salyan", "Shantinagar",
      "Simkot", "Sinja", "Soru", "Subha Kalika", "Surkhet", "Tatopani",
      "Thuli Bheri", "Tilagupha", "Tripurasundari"
    ],
    "Sudurpashchim Province": [
      "Ajaymeru", "Alital", "Amargadhi", "Apihimal", "Badikedar",
      "Bhageshwar", "Chure", "Dadeldhura", "Dasharathchanda", "Dhangadhi",
      "Dipayal Silgadhi", "Dogadakedar", "Ganayapdhura", "Ghodaghodi",
      "Godawari", "Gulariya", "Janaki", "Joshipur", "Kailali", "Kailari",
      "Kanchanpur", "Krishnapur", "Laljhadi", "Lamkichuha", "Mahakali",
      "Melauli", "Mohanyal", "Nawadurga", "Parashuram", "Patan",
      "Puchaundi", "Punarbas", "Shikhar", "Shuklaphanta National Park",
      "Shuklaphanta", "Sigas", "Simta", "Surnaya", "Tikapur"
    ]
  };

  useEffect(() => {
    handle_get_firms();
  }, []);

  console.log('email---', email);

  const handle_get_firms = async () => {
    try {
      const response2 = await axios.get(
        `https://api-portal.nada.org.np/api/firms/${id}`,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        }
      );
      if (response2?.data?.success) {
        //setData(response2?.data?.data?.firms);
        setName(response2?.data?.data?.firm?.[0]?.name_of_firm);
        setPanNumber(response2?.data?.data?.firm?.[0]?.pan_number);
        // Inside handle_get_firms function

      const orgTypeString = response2?.data?.data?.firm?.[0]?.type_of_organization;

      const titleOptionArray = orgTypeString
        ? orgTypeString.split(",").map((item) => ({
            label: item,
            value: item,
          }))
        : []; // Return empty array if null
        setTypeOfOrganizationValid(titleOptionArray);
        setSelectedTitleOption(titleOptionArray);
        setContactPerson(response2?.data?.data?.firm?.[0]?.contact_person);
        setPhoneNumber(response2?.data?.data?.firm?.[0]?.contact_person_num);
        setPendingAmt(response2?.data?.data?.firm?.[0]?.pending_amt);
        setSelectedProvinceOption(response2?.data?.data?.firm?.[0]?.province);
        setSelectedDistrictOption(response2?.data?.data?.firm?.[0]?.district);
        setLatitude(response2?.data?.data?.firm?.[0]?.latitude);
        setLongitude(response2?.data?.data?.firm?.[0]?.longitude);
        setEmail(response2?.data?.data?.firm?.[0]?.email !== null? response2?.data?.data?.firm?.[0]?.email : "");
        setNoOfYears(response2?.data?.data?.firm?.[0]?.no_of_years);
        setSelectedCityOption(response2?.data?.data?.firm?.[0]?.city);
        setOtherDocS(response2?.data?.data?.firm?.[0]?.other_document ?? []);
        setAddress(response2?.data?.data?.firm?.[0]?.address);
        setStampPicS(response2?.data?.data?.firm?.[0]?.stamp_of_firm);

        const actualPosition = positions?.filter(p => p === response2?.data?.data?.firm?.[0]?.position);

        setPosition(actualPosition?.length ? "" : response2?.data?.data?.firm?.[0]?.position);
        setSelectedPositionOption(actualPosition?.length ? actualPosition[0] : "Other");
        var payType2 = response2?.data?.data?.firm?.[0]?.membership_status === 1? "Unpaid" : "Paid";
        setFirmOption2(payType2);
        var payType3 = response2?.data?.data?.firm?.[0]?.agm_status === 1? "Unpaid" : "Paid";
        setFirmOption3(payType3);
        var payType5 = response2?.data?.data?.firm?.[0]?.province_status === 1? "Unpaid" : "Paid";
        setFirmOption5(payType5);
        var payType4 = response2?.data?.data?.firm?.[0]?.membership_status_new === 1? "Inactive" : "Active";
        setFirmOption4(payType4);
        setSupportingPicS(
          response2?.data?.data?.firm?.[0]?.supporting_document
        );
        setSupportingPic2S(
          response2?.data?.data?.firm?.[0]?.supporting_document2
        );
        setProfilePicS(
          response2?.data?.data?.firm?.[0]?.pp_image
        );
        setPaymentProof(response2?.data?.data?.firm?.[0]?.payment_proof);
        setPaymentProof2(response2?.data?.data?.firm?.[0]?.payment_proof_agm);
        setPaymentProof3(response2?.data?.data?.firm?.[0]?.payment_proof_new);
        setPaymentProof4(response2?.data?.data?.firm?.[0]?.province_proof);
        var payType = response2?.data?.data?.firm?.[0]?.payment_type === 1? "New Membership" : "Renewal Membership";
        setPaymentType(payType);
        setFirmOption(
          response2?.data?.data?.firm?.[0]?.status === 1
            ? "Submitted"
            : response2?.data?.data?.firm?.[0]?.status === 2
            ? "Send for Edits"
            : response2?.data?.data?.firm?.[0]?.status === 3
            ? "Accepted"
            : response2?.data?.data?.firm?.[0]?.status === 4
            ? "Rejected"
            : response2?.data?.data?.firm?.[0]?.status === 10
            ? "Uploaded"
            : "Rejected"
        );
      }
    } catch (error) {
      if (error.response) {
        console.error("Error response:", error.response);
        toast.error(error.response.data.message || "An error occurred");
      } else if (error.request) {
        console.error("Error request:", error.request);
        toast.error("No response received from server");
      } else {
        console.error("Error message:", error.message);
        toast.error(error.message);
      }
    }
  };

  var ids = 0;

  useEffect(() => {
    if (isInitialRender.current) {
      isInitialRender.current = false;
      return;
    }

    setSelectedDistrictOption(unfilteredDistricts[provinceOption]?.[0]);
    setSelectedCityOption(unfilteredCities[provinceOption]?.[0]);
    setDistricts(unfilteredDistricts[provinceOption] || []);

    setCities(unfilteredCities[provinceOption] || []);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [provinceOption]);




  const resizeImage = (file, maxWidth, maxHeight) => {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.readAsDataURL(file);

      reader.onload = (event) => {
        const img = new window.Image();
        img.src = event.target.result;

        img.onload = () => {
          const canvas = document.createElement('canvas');
          const ctx = canvas.getContext('2d');

          let width = img.width;
          let height = img.height;

          // Calculate the new dimensions to maintain aspect ratio
          if (width > height) {
            if (width > maxWidth) {
              height = Math.round(height * (maxWidth / width));
              width = maxWidth;
            }
          } else {
            if (height > maxHeight) {
              width = Math.round(width * (maxHeight / height));
              height = maxHeight;
            }
          }

          canvas.width = width;
          canvas.height = height;

          // Draw the resized image onto the canvas
          ctx.drawImage(img, 0, 0, width, height);

          // Convert canvas to a Blob, then to a File
          canvas.toBlob(
            (blob) => {
              if (!blob) {
                reject(new Error('Canvas to Blob conversion failed.'));
                return;
              }
              const resizedFile = new File([blob], file.name, {
                type: file.type,
                lastModified: Date.now(),
              });
              resolve(resizedFile);
            },
            file.type,
            0.95 // Image quality for JPEG/WEBP (0.0 to 1.0)
          );
        };

        img.onerror = (error) => reject(error);
      };

      reader.onerror = (error) => reject(error);
    });
  };


  useEffect(() => {

    if(provinceOption ===  "Bagmati Province" && (districtOption === "Hetauda" || districtOption === "Chitwan")) {
      if(districtOption === "Hetauda") {
        setProReqFees(2100);
      } else {
        setProReqFees(5000);
      }
    } else if(provinceOption ===  "Province No. 1") {
      setProReqFees(2400);
    }else if(provinceOption ===  "Province No. 2") {
      setProReqFees(2500);
    }else if(provinceOption ===  "Gandaki Province") {
      setProReqFees(7000);
    }else if(provinceOption ===  "Lumbini Province") {
      setProReqFees(5106);
    }else if(provinceOption ===  "Karnali Province") {
      setProReqFees(1100);
    }else {
      setProReqFees(0);
    }
  }, [provinceOption, districtOption]);

  const handleClick = (link, e) => {
    e.preventDefault();
    window.open(link, "_blank", "noopener,noreferrer");
  };

  const getLocation = (e) => {
    e.preventDefault();
    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition(
        (position) => {
          setLocation({
            latitude: position.coords.latitude,
            longitude: position.coords.longitude,
          });
          setLatitude(position.coords.latitude);
          setLongitude(position.coords.longitude);
          setError(null);
        },
        (error) => {
          setError(error.message);
        }
      );
    } else {
      setError("Geolocation is not supported by this browser.");
    }
  };

  const getUploadParams4 = ({ meta }) => {
    return { url: "https://httpbin.org/post" };
  };

  const validateImageDimensions = (file, callback) => {
    const reader = new FileReader();
    reader.onload = (event) => {
      const img = new window.Image();;
      img.src = event.target.result;

      img.onload = () => {
        const maxWidth = 134; // Maximum allowed width
        const maxHeight = 170; // Maximum allowed height

        if (img.width > maxWidth || img.height > maxHeight) {
          callback(
            false,
            `Image dimensions must be ${maxWidth}x${maxHeight}px. Uploaded image size: ${img.width}x${img.height}px.`
          );
        } else {
          callback(true);
        }
      };
    };
    reader.readAsDataURL(file);
  };

  const handleChangeStatus4 = async ({ meta, file, remove }, status) => {
    if (status === 'done') {
      try {
        // Resize the image to fit within a 134x170 box
        const resizedFile = await resizeImage(file, 134, 170);

        console.log('Original file size:', file.size);
        console.log('Resized file size:', resizedFile.size);

        // Set the new, resized file in your state
        setProfilePic(resizedFile);

        toast.success('Image has been resized and is ready!');

      } catch (error) {
        console.error('Image processing failed:', error);
        toast.error('Could not process the image. Please try a different file.');
        remove(); // Remove the file from the dropzone on error
      }
    }

    if (status === 'removed') {
      // Handle file removal if needed
      setProfilePic(null);
    }
  };

  const getUploadParams5 = ({ meta }) => {
    return { url: "https://httpbin.org/post" };
  };

  const handleChangeStatus5 = ({ meta, file }, status) => {
    if (status === 'done') {
      setOtherDoc((prev) => [...prev, file]); // Add file to the array
    } else if (status === 'removed') {
      setOtherDoc((prev) => prev.filter((f) => f !== file)); // Remove file from the array
    }
  };

// Empty checks should be type-aware
const isEmpty = (val) => {
  if (val == null) return true;                 // null or undefined
  if (typeof val === 'string') return val.trim() === '';
  if (Array.isArray(val)) return val.length === 0;
  // For File/Blob/Object/number/boolean, treat "present" as non-empty
  return false;
};

// Make sure we check digit count even if number/string mix
const isValidPhone = (num) => {
  if (num == null) return false;
  const s = String(num).replace(/\D/g, '');     // keep digits only
  return s.length === 10;
};

const isValidEmail = (em) => isEmpty(em) ? true : validateEmail(em);


  const handleAdd = async (e) => {
    e.preventDefault();
    const nameOk = !isEmpty(name);
    const profileOk = !isEmpty(profilePic) || !isEmpty(profilePicS);
    const panOk = !isEmpty(panNumber);
    const positionOk = positionOption === "Other" ? !isEmpty(position) : true;
    const stampOk = !isEmpty(stampPic) || !isEmpty(stampPicS);
    const contactOk = same ? true : !isEmpty(contactPerson);
    const phoneOk = same ? true : isValidPhone(phone_number);
    const emailOk = isValidEmail(email);
    const addressOk = !isEmpty(address);
    const cityOk = !isEmpty(cityOption);
    const latitudeOk = !isEmpty(latitude);
    const longitudeOk = !isEmpty(longitude);

    setNameValid(nameOk);
    setProfilePicValid(profileOk);
    setPanValid(panOk);
    setPositionValid(positionOk);
    setStampValid(stampOk);
    setContactPersonValid(contactOk);
    setPhoneNumberValid(phoneOk);
    setEmailValid(emailOk);
    setAddressValid(addressOk);
    setLatitudeValid(latitudeOk);
    setLongitudeValid(longitudeOk);
    setCityValid(cityOk);

    if (
      /*nameOk &&
      profileOk &&
      panOk &&
      positionOk &&
      stampOk &&
      contactOk &&
      phoneOk &&
      emailOk &&
      addressOk &&
      latitudeOk &&
      longitudeOk &&
      cityOk*/
      true
    ) {
      console.log('I am here 2');
      try {
        setLoading(true);
        let stamp;
        let pp;
        let support;
        let support2;
        let otherDocy;
        let combinedDoc;

        if (profilePic) {
          pp = await call_picture_upload(profilePic);
        }
        if (stampPic) {
          stamp = await call_picture_upload(stampPic);
        }
        if (supportingPic) {
          support = await call_picture_upload(supportingPic);
        }
        if (supportingPic2) {
          support2 = await call_picture_upload(supportingPic2);
        }

        if(otherDoc?.length > 0) {
          otherDocy = await Promise.all(
            otherDoc.map((file) => call_picture_upload(file)));
        }

        if (otherDocy?.length > 0 && otherDocS?.length > 0) {
          combinedDoc = [...otherDocy, ...otherDocS];
        }

        const response2 = await axios.put(
          `https://api-portal.nada.org.np/api/firms/${id}`,
          {
            name_of_firm: name,
            no_of_years: noOfYears,
            pan_number: panNumber,
            province: provinceOption,
            pp_image: pp
            ? pp
            : profilePicS
            ? profilePicS
            : "",
            stamp_of_firm: stamp ? stamp : stampPicS  ? stampPicS  : "",
            type_of_organization:
              titleOption?.length > 1
                ? titleOption?.map((option) => option.value).join(",")
                : titleOption?.[0]?.value,
            contact_person_num: phone_number,
            supporting_document: support
              ? support
              : supportingPicS
              ? supportingPicS
              : "",
            supporting_document2: support2
              ? support2
              : supportingPic2S
              ? supportingPic2S
              : "",
            address: address,
            district: districtOption,
            contact_person: contactPerson,
            city: cityOption,
            status:
              firmOption === "Submitted"
                ? 1
                : firmOption === "Send for Edits"
                ? 2
                : firmOption === "Accepted"
                ? 3
                : firmOption === "Rejected"
                ? 4
                : firmOption === "Uploaded"
                ? 10
                : 4,
            status_note: text,
            latitude: latitude,
            province_fee: proReqFees,
            longitude: longitude,
            position: positionOption === 'Other' ? position : positionOption,
            payment_proof: paymentProof,
            other_document:
            combinedDoc && combinedDoc.length !== 0 ? combinedDoc :
            otherDocy && otherDocy.length !== 0 ? otherDocy :
            otherDocS && otherDocS?.length !== 0 ? otherDocS :
            [],
            payment_proof_new: paymentProof3,
            payment_type: paymentType === "New Membership"? 1 : 2,
            membership_status: firmOption2 === "Unpaid"? 1 : 2,
            agm_status: firmOption3 === "Unpaid"? 1 : 2,
            province_status: firmOption5 === "Unpaid"? 1 : 2,
            province_proof: paymentProof4,
            membership_status_new: firmOption4 === "Inactive"? 1 : 2,
            payment_proof_agm: paymentProof2,
          },
          {
            headers: {
              "Content-Type": "application/json",
              "access-control-allow-origin": "*",
              Authorization: `Bearer ${token}`,
            },
          }
        );

        if (response2?.data?.success) {
          setLoading(false);
          toast.success("Firm submitted successfully.");
          navigate("/firms");
          //setData(response2?.data?.data?.firms);
        }
      } catch (error) {
        setLoading(false);
        if (error.response) {
          console.error("Error response:", error?.response);
          toast.error(error?.response?.data?.message || "An error occurred");
        } else if (error?.request) {
          console.error("Error request:", error?.request);
          toast.error("No response received from server");
        } else {
          console.error("Error message:", error?.message);
          toast.error(error?.message);
        }
      }
    } else {
      toast.error(t("Please fill all required fields correctly"));
    }
  };

  const firm_status = ["Uploaded", "Submitted", "Send for Edits", "Accepted", "Rejected"];

  const titles2 = [
    { value: "(FY-82/83)", label: "(FY-82/83)" },
    { value: "(FY-83/84)", label: "(FY-83/84)" },
    { value: "(FY-84/85)", label: "(FY-84/85)" },
    { value: "(FY-85/86)", label: "(FY-85/86)" },
    { value: "(FY-86/87)", label: "(FY-86/87)" },
  ];

  const call_picture_upload = async (file) => {
    // 1. Get the Presigned URL
    const getUrl = await axios.get(
      `https://api-portal.nada.org.np/api/upload-url?filename=${file.name}&fileType=${file.type}`,
      {
        headers: {
             // Ensure you are sending auth if your backend requires it
            'Authorization': `Bearer ${token}`
        },
      }
    );

    const { uploadUrl, key } = getUrl.data;

    // 2. Upload to S3 (Crucial Fix Here)
    await axios.put(
      uploadUrl,
      file, // <--- Pass 'file' directly. Do NOT wrap in { body: file }
      {
        headers: {
            "Content-Type": file.type
        }
      }
    );

    return "https://d24xzirvx50zjt.cloudfront.net/" + key;
};

  useEffect(() => {
    const placeRemains  = 4 - otherDocS?.length;
    if(placeRemains > 0) {
      setPlaceRemain(placeRemains);
    } else {
      setPlaceRemain(0);
    }
  }, [otherDocS]);

  const toggle = useCallback((index) => {
    const newArray = [...otherDocS]; // Create a copy of the array
    newArray.splice(index, 1); // Remove the element at the specified index

    setOtherDocS(newArray); // Update the state with the new array
  }, [otherDocS]);

  console.log('place remains', placeRemain);

  return (
    <Fragment>
      <Form className="card" onSubmit={(e) => handleAdd(e)}>
        <CardHeader className="pb-0">
          <div className="card-options">
            <a className="card-options-collapse" href="#javascript">
              <i className="fe fe-chevron-up"></i>
            </a>
            <a className="card-options-remove" href="#javascript">
              <i className="fe fe-x"></i>
            </a>
          </div>
        </CardHeader>
        <CardBody>
          <Row>
            <Col md="5">
              <FormGroup className="mb-3">
                {" "}
                <Label className="form-label">{t("Name of Firm")}</Label>
                <input
                  className="form-control"
                  name="name"
                  type="text"
                  placeholder={t("Name of Firm")}
                  style={{ borderColor: !nameValid ? "#EB0A1E" : null }}
                  value={name}
                  onChange={(e) => setName(e.target.value)}
                />
                <span style={{ color: "red" }}>
                  {!nameValid && t("Name is required")}{" "}
                </span>
              </FormGroup>
            </Col>
            <Col sm="6" md="3">
              <FormGroup>
                {" "}
                <Label className="form-label">{t("Pan Number")}</Label>
                <input
                  className="form-control"
                  name="phone"
                  type="text"
                  placeholder={t("Pan Number")}
                  value={panNumber}
                  onChange={(e) => setPanNumber(e.target.value)}
                  //{...register("pan", { required: true })}
                />
                <span style={{ color: "red" }}>
                {!panValid && `${t("Pan Number is required")}`}{" "}
                </span>
              </FormGroup>
            </Col>
            <Col sm="6" md="4">
              <div style={{ marginTop: -8 }}>
                <Label className="col-form-label">{t("Type of Firm")}</Label>
                <Select
                  options={titles}
                  value={titleOption}
                  onChange={setSelectedTitleOption}
                  className="js-example-basic-single col-sm-12"
                  isMulti
                />
              </div>
            </Col>
            <Col sm="6" md="3">
              <FormGroup>
                <Label className="form-label">{t("Email")}</Label>
                <input
                  className="form-control"
                  name="email"
                  type="text"
                  style={{
                    borderColor: !emailValid ? "#EB0A1E" : null,
                  }}
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  placeholder={t("Email")}
                  //{...register("FirstName", { required: true })}
                />
                 <span style={{ color: "red" }}>
                  {!emailValid && t("Email is invalid")}{" "}
                </span>
              </FormGroup>
            </Col>
            <Col sm="6" md="3">
              <FormGroup>
                <Label className="form-label">{t("Contact Person")}</Label>
                <input
                  className="form-control"
                  name="FirstName"
                  type="text"
                  style={{
                    borderColor: !contactPersonValid ? "#EB0A1E" : null,
                  }}
                  disabled={same}
                  value={contactPerson}
                  onChange={(e) => setContactPerson(e.target.value)}
                  placeholder={t("Contact Person")}
                  //{...register("FirstName", { required: true })}
                />
                <span style={{ color: "red" }}>
                {!contactPersonValid && t("Contact Person is required")}{" "}
                </span>
                <div className="form-check form-check-inline checkbox checkbox-primary">
                  <Input
                    id="inline-form-1"
                    type="checkbox"
                    checked={same}
                    onChange={handleCheckboxChange}
                  />
                  <Label className="mb-0" htmlFor="inline-form-1">
                  {t("same as logged user?")}
                  </Label>
                </div>
              </FormGroup>
            </Col>
            <Col sm="6" md="3">
              <FormGroup>
                <Label className="form-label">{t("Phone Number")}</Label>
                <input
                  className="form-control"
                  name="phone"
                  type="text"
                  disabled={same}
                  style={{ borderColor: !phoneNumberValid ? "#EB0A1E" : null }}
                  placeholder={t("Phone Number")}
                  value={phone_number}
                  onChange={(e) => setPhoneNumber(e.target.value)}
                  //{...register("phone", { required: true })}
                />
                <span style={{ color: "red" }}>
                {!phoneNumberValid && t("Phone Number is required")}{" "}
                </span>
              </FormGroup>
            </Col>
            <Col sm="6" md="3">
              <FormGroup>
                <Label className="form-label">{t("Position")}</Label>
                <SingleSelect
                  options={positions}
                  selectedOption={positionOption}
                  onChange={setSelectedPositionOption}
                />
                {positionOption === 'Other' &&
                <input
                  className="form-control"
                  name="phone"
                  type="text"
                  disabled={same}
                  style={{ borderColor: !positionValid ? "#EB0A1E" : null, marginTop: 6 }}
                  placeholder={t("Specify..")}
                  value={position}
                  onChange={(e) => setPosition(e.target.value)}
                  //{...register("phone", { required: true })}
                />
                }
                <span style={{ color: "red" }}>
                {!positionValid && t("Position is required")}{" "}
                </span>
              </FormGroup>
            </Col>
            <Col sm="6" md="3">
              <div>
                {" "}
                <Label className="form-label">
                {t("Update Contact Person Passport Photo")}(jpeg/png,134 * 170)
                </Label>
                <Dropzone1
                accept="image/jpeg,image/png"
                  getUploadParams={getUploadParams4}
                  handleChangeStatus={handleChangeStatus4}
                />
                {profilePicS && (
                  <>
                   <Image attrImage={{
                    body: true, className: 'img-100 rounded-circle', src: `${profilePicS}`, alt: '',
                  }}
                  />

                 {/*<Btn
                    attrBtn={{
                      color: "secondary",
                      onClick: (e) => handleClick(profilePicS, e),
                    }}
                    style={{
                      display: "flex",

                      alignItems: "center",
                      justifyContent: "center",
                    }}
                  >
                    {t("View current Photo")}
                  </Btn>*/}
                  </>
                )}
                <span style={{ color: "red" }}>
                  {!profilePicValid && t("Passport Size Photo is required")}{" "}
                </span>
              </div>
            </Col>
            <Col sm="6" md="3">
              <div>
                <Label className="col-form-label">{t("Province")}</Label>
                <SingleSelect
                  options={provinces}
                  selectedOption={provinceOption}
                  onChange={setSelectedProvinceOption}
                />
              </div>
            </Col>
            <Col sm="6" md="3">
              <div>
                <Label className="col-form-label">{t("District")}</Label>
                <SingleSelect
                  options={districts}
                  selectedOption={districtOption}
                  onChange={setSelectedDistrictOption}
                />
              </div>
            </Col>
            <Col sm="6" md="3">
              <div>
                <Label className="col-form-label">{t("City")}</Label>
                <SingleSelect
                  options={cities}
                  selectedOption={cityOption}
                  onChange={setSelectedCityOption}
                />
              </div>
              <span style={{ color: "red" }}>
                {!cityValid && t("city is required")}{" "}
                </span>
            </Col>
            <Col sm="6" md="3" style={{ marginTop: 6 }}>
              <FormGroup>
                <Label className="form-label">{t("Address")}</Label>
                <input
                  className="form-control"
                  name="phone"
                  type="text"
                  placeholder={t("Address")}
                  value={address}
                  onChange={(e) => setAddress(e.target.value)}
                  //{...register("address", { required: true })}
                />
                <span style={{ color: "red" }}>
                {!addressValid && t("Address is required")}{" "}
                </span>
              </FormGroup>
            </Col>

            <Col sm="6" md="3">
              <FormGroup>
                {" "}
                <Label className="form-label">{t("Firm Latitude")}</Label>
                <input
                  className="form-control"
                  name="phone"
                  type="text"
                  style={{ borderColor: !latitudeValid ? "#EB0A1E" : null }}
                  placeholder={t("Firm Latitude")}
                  value={latitude}
                  onChange={(e) => setLatitude(e.target.value)}
                  //{...register("pan", { required: true })}
                />
                <span style={{ color: "red" }}>
                  {!latitudeValid && "Latitude is required"}{" "}
                </span>
              </FormGroup>
            </Col>
            <Col sm="6" md="3">
              <FormGroup>
                {" "}
                <Label className="form-label">{t("Firm Longitude")}</Label>
                <input
                  className="form-control"
                  name="longitude"
                  type="text"
                  placeholder={t("Firm Longitude")}
                  style={{ borderColor: !longitudeValid ? "#EB0A1E" : null }}
                  value={longitude}
                  onChange={(e) => setLongitude(e.target.value)}
                  //{...register("longitude", { required: true })}
                />
                <span style={{ color: "red" }}>
                  {!longitudeValid && "Longitude is required"}{" "}
                </span>
              </FormGroup>
            </Col>
            <Col sm="6" md="3" style={{ marginTop: 27 }}>
              <Btn
                attrBtn={{
                  color: "primary",
                  type: "submit",
                  onClick: (e) => getLocation(e),
                }}
              >
                {t("Set Current Location")}
              </Btn>
            </Col>
            <Col sm="6" md="4">
              <div>
                {" "}
                <Label className="form-label">{t("Update Stamp of firm")}(jpeg/png,160 * 160)</Label>
                <Dropzone1
                  accept="image/jpeg,image/png"
                  getUploadParams={getUploadParams}
                  handleChangeStatus={handleChangeStatus}
                  placeholder={t("Stamp")}
                />
                {stampPicS && (
                  <Btn
                    attrBtn={{
                      color: "secondary",
                      onClick: (e) => handleClick(stampPicS, e),
                    }}
                    style={{
                      display: "flex",

                      alignItems: "center",
                      justifyContent: "center",
                    }}
                  >
                    {t("View current Stamp")}
                  </Btn>
                )}
              </div>
              <span style={{ color: "red" }}>
                {!stampValid && t("Stamp Image is required")}{" "}
              </span>
            </Col>
            <Col sm="6" md="4">
              <div>
                {" "}
                <Label className="form-label">{t("Update Supporting Document")}</Label>
                <Dropzone1
                  getUploadParams={getUploadParams2}
                  handleChangeStatus={handleChangeStatus2}
                  placeholder={t("NADA Document")}
                />
                {supportingPicS && (
                  <Btn
                    attrBtn={{
                      color: "secondary",
                      onClick: (e) => handleClick(supportingPicS, e),
                    }}
                    style={{
                      display: "flex",

                      alignItems: "center",
                      justifyContent: "center",
                    }}
                  >
                    {t("View current supporting document")}
                  </Btn>
                )}
              </div>
            </Col>
            <Col sm="6" md="4">
              <div>
                {" "}
                <Label className="form-label">
                  {t("Update Another Supporting Document")}
                </Label>
                <LI>{t("ncell1")}</LI>
                <LI>{t("ncell2")}</LI>
                <LI>{t("ncell3")}</LI>
                <Dropzone1
                  getUploadParams={getUploadParams3}
                  placeholder={t("Phone number owner's proof.")}
                  handleChangeStatus={handleChangeStatus3}
                />
                {supportingPic2S && (
                  <Btn
                    attrBtn={{
                      color: "secondary",
                      onClick: (e) => handleClick(supportingPic2S, e),
                    }}
                    style={{
                      display: "flex",

                      alignItems: "center",
                      justifyContent: "center",
                    }}
                  >
                    {t("View current supporting document 2")}
                  </Btn>
                )}
              </div>
            </Col>
            <Col sm="7" md="8">
              <div>
                {" "}
                <Label className="form-label">{t("Other Documents Upload")}(pdf/png/jpeg)</Label>
                <Dropzone1
                  multi={true}
                  noOfFiles={placeRemain}
                  getUploadParams={getUploadParams5}
                  handleChangeStatus={handleChangeStatus5}
                   placeholder="NADA Document."
                />
              </div>
              {Array.isArray(otherDocS) && otherDocS.length > 0 && (
  otherDocS.map((doc, index) => (
    <div
      key={index} // Don't forget the key prop!
      style={{
        display: "flex",
        flexDirection: 'row',
        width: "100%",
        justifyContent: "space-between",
        alignItems: "center",
        gap: 20,
      }}
    >
      <Btn
        attrBtn={{
          color: "secondary",
          onClick: (e) => handleClick(doc, e),
        }}
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        {t("View current doc")} {index + 1}
      </Btn>
      <div style={{ cursor: 'pointer' }} onClick={() => toggle(index)}>
        <Trash2 />
      </div>
    </div>
  ))
)}
            </Col>
            <Col sm="12">
              <Label className="col-form-label">{t("Firm Notes")}</Label>
              <SimpleMDE
                id="container"
                onChange={handleChange}
                style={{ background: 'transparent !important' }}
                value={text}
              />
            </Col>
            <Col sm="6" md="3">
              <div>
                <Label className="col-form-label">{t("Firm Status")}</Label>
                <SingleSelect
                  options={firm_status}
                  selectedOption={firmOption}
                  onChange={setFirmOption}
                />
              </div>
            </Col>
          </Row>
          <Row
            style={{
              marginTop: 20,
              paddingTop: '20px',
              paddingBottom: '20px',
              marginBottom: 20,
              backgroundColor: "#f8f9fa",
              borderRadius: 10,
            }}
          >
          <Col sm="6" md="3">
              <div
                style={{ display: 'flex', flexDirection: "column", marginTop: 10 }}
              >
                <Label className="col-form-label">{t("New Membership Payment proof")}</Label>
                {paymentProof3?
                  <Btn
                    attrBtn={{
                      color: "secondary",
                      onClick: (e) => handleClick(paymentProof3, e),
                    }}
                    style={{
                      display: "flex",

                      alignItems: "center",
                      justifyContent: "center",
                    }}
                  >
                    {t("View Payment proof")}
                  </Btn>
                : <Label className="form-label">{t("No New Membership Payment proof found")}</Label>}
              </div>
            </Col>
            <Col sm="6" md="3">
              <div>
                <Label className="col-form-label">{t("New Membership Status")}</Label>
                <SingleSelect
                  options={firm_status2}
                  selectedOption={firmOption4}
                  onChange={setFirmOption4}
                />
              </div>
            </Col>
          </Row>
          <Row
            style={{
              paddingTop: '20px',
              paddingBottom: '20px',
              marginTop: 20,
              marginBottom: 20,
              backgroundColor: "#f8f9fa",
              borderRadius: 10,
            }}
          >
          <Col sm="6" md="3">
              <div
                style={{ display: 'flex', flexDirection: "column", marginTop: 10 }}
              >
                <Label className="col-form-label">{t("Payment proof")}</Label>
                {paymentProof?
                  <Btn
                    attrBtn={{
                      color: "secondary",
                      onClick: (e) => handleClick(paymentProof, e),
                    }}
                    style={{
                      display: "flex",

                      alignItems: "center",
                      justifyContent: "center",
                    }}
                  >
                    {t("View Payment proof")}
                  </Btn>
                : <Label className="form-label">{t("No Payment proof found")}</Label>}
              </div>
            </Col>
            <Col sm="6" md="3">
              <div>
                <Label className="col-form-label">{t("Membership Status")}</Label>
                <SingleSelect
                  options={firm_status3}
                  selectedOption={firmOption2}
                  onChange={setFirmOption2}
                />
              </div>
            </Col>
            <Col sm="6" md="3">
              <div
              >
                <Label className="col-form-label">{t("Fiscal Years(Membership)")}:{' '}</Label>
               {/*<input
  className="form-contr
  name="phone"
  type="number"
  disabled={true}
  placeholder={t("Number of Years")}
  value={noOfYears}
  min="1" // Ensures the value cannot be less than 1
  onChange={(e) => {
    const value = Math.max(1, e.target.value); // Ensures the value is at least 1
    setNoOfYears(value);
  }}
 />*/}
{Array.isArray(titles2) && noOfYears > 0 && titles2.slice(0, noOfYears).map((year, index) => {
  return <LI key={index}>{year?.label}</LI>;
})}


              </div>
            </Col>
            {pendingAmt &&
            <Col sm="6" md="3">
            <div
            >
              <Label className="col-form-label">{t("Pending Amount")}:{' '}</Label>
              <LI>{pendingAmt}</LI>
            </div>
          </Col>
            }
          </Row>
          <Row
            style={{
              marginTop: '20px',
              paddingTop: '20px',
              paddingBottom: '20px',
              marginBottom: 20,
              backgroundColor: "#f8f9fa",
              borderRadius: 10,
            }}
          >
            <Col sm="6" md="3">
              <div
                style={{  display: 'flex', flexDirection: "column", marginTop: 10 }}
              >
                <Label className="col-form-label">{t("AGM Payment proof")}</Label>
                {paymentProof2?
                  <Btn
                    attrBtn={{
                      color: "secondary",
                      onClick: (e) => handleClick(paymentProof2, e),
                    }}
                    style={{
                      display: "flex",

                      alignItems: "center",
                      justifyContent: "center",
                    }}
                  >
                    {t("View Payment proof")}
                  </Btn>
                : <Label className="form-label">{t("No Payment proof found")}</Label>}
              </div>
            </Col>
            <Col sm="6" md="3">
              <div>
                <Label className="col-form-label">{t("AGM Status")}</Label>
                <SingleSelect
                  options={firm_status3}
                  selectedOption={firmOption3}
                  onChange={setFirmOption3}
                />
              </div>
            </Col>
          </Row>
          <Row
            style={{
              marginTop: '20px',
              paddingTop: '20px',
              paddingBottom: '20px',
              marginBottom: 20,
              backgroundColor: "#f8f9fa",
              borderRadius: 10,
            }}
          >
            <Col sm="6" md="3">
              <div
                style={{  display: 'flex', flexDirection: "column", marginTop: 10 }}
              >
                <Label className="col-form-label">{t("Provincial Payment proof")}</Label>
                {paymentProof4?
                  <Btn
                    attrBtn={{
                      color: "secondary",
                      onClick: (e) => handleClick(paymentProof4, e),
                    }}
                    style={{
                      display: "flex",

                      alignItems: "center",
                      justifyContent: "center",
                    }}
                  >
                    {t("View Payment proof")}
                  </Btn>
                : <Label className="form-label">{t("No Payment proof found")}</Label>}
              </div>
            </Col>
            <Col sm="6" md="3">
            <Label className="col-form-label">{t("Provincial Fees to be paid")}: Rs {proReqFees}</Label>
            </Col>
            <Col sm="6" md="3">
              <div>
                <Label className="col-form-label">{t("Province Status")}</Label>
                <SingleSelect
                  options={firm_status3}
                  selectedOption={firmOption5}
                  onChange={setFirmOption5}
                />
              </div>
            </Col>
          </Row>
        </CardBody>
        <CardFooter className="text-end">
          {loading ? (
            <div className="loader-box">
              <Spinner attrSpinner={{ className: "loader-2" }} />
            </div>
          ) : (
            <Btn attrBtn={{ color: "primary", type: "submit" }}>
              {t("Update Firm")}
            </Btn>
          )}
        </CardFooter>
      </Form>
    </Fragment>
  );
};
export default EditMyProfile;
